import { toast } from "sonner";
import api from "@/lib/api";
import { hasPerm } from "@/lib/auth";
import { PrinterIcon, FilePdfIcon, FileXlsIcon } from "@phosphor-icons/react";

export const fmtQ = (v) => Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 3, maximumFractionDigits: 3 });

export const fyStart = () => {
  const t = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
  const y = t.getMonth() >= 3 ? t.getFullYear() : t.getFullYear() - 1;
  return `${y}-04-01`;
};
export const todayIst = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const errMsg = async (e) => {
  try {
    const txt = await e?.response?.data?.text?.();
    const d = JSON.parse(txt || "{}").detail;
    return (d && (d.message || d)) || "Export failed";
  } catch { return "Export failed"; }
};

async function fetchFile(format, params) {
  const res = await api.get("/inventory/v2/stock-report/export", { params: { format, ...params }, responseType: "blob" });
  const name = /filename="([^"]+)"/.exec(res.headers?.["content-disposition"] || "")?.[1] || `stock-report.${format}`;
  return { blob: res.data, name };
}

const download = ({ blob, name }) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
};

// Print uses the exact same server PDF as Download PDF (parity by construction).
const printPdf = ({ blob }) => {
  const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
  document.getElementById("__sr_print")?.remove();
  const f = document.createElement("iframe");
  f.id = "__sr_print";
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  f.src = url;
  f.onload = () => { try { f.contentWindow.focus(); f.contentWindow.print(); } catch { window.open(url, "_blank"); } };
  document.body.appendChild(f);
};

export function ExportButtons({ params, disabled, prefix }) {
  const canPrint = hasPerm(null, "stock_engine:print");
  const canExport = hasPerm(null, "stock_engine:export");
  const run = async (format, then) => {
    try { then(await fetchFile(format, params)); } catch (e) { toast.error(await errMsg(e)); }
  };
  const btn = "h-9 px-3 rounded-sm border border-[var(--border)] text-xs font-mono uppercase tracking-widest flex items-center gap-1.5 hover:bg-[var(--bg-2)] disabled:opacity-40 disabled:cursor-not-allowed";
  return (
    <div className="flex items-center gap-2">
      {canPrint && <button type="button" data-testid={`${prefix}-print`} disabled={disabled} className={btn} onClick={() => run("pdf", printPdf)}><PrinterIcon size={14} /> Print</button>}
      {canPrint && <button type="button" data-testid={`${prefix}-pdf`} disabled={disabled} className={btn} onClick={() => run("pdf", download)}><FilePdfIcon size={14} /> Download PDF</button>}
      {canExport && <button type="button" data-testid={`${prefix}-xlsx`} disabled={disabled} className={btn} onClick={() => run("xlsx", download)}><FileXlsIcon size={14} /> Export Excel</button>}
    </div>
  );
}
